import services from 'services/module';
import {animatronProject} from '../lazy_modules';
import SpinnerSvc from 'services/SpinnerSvc';
import {Utils} from '../underscore-extensions';

export class ProjectModalSvc {
    projectModalShown: boolean;

    private prevState: ng.ui.IState;
    private prevParams: ng.ui.IStateParamsService;

    constructor(private $rootScope: ng.IRootScopeService,
                private $state: ng.ui.IStateService,
                private $timeout: ng.ITimeoutService,
                private $ocLazyLoad: oc.ILazyLoad) {
        this.prevState = $state.current;
        this.prevParams = $state.params;

        if (this.projectModalShown !== true) {
            this.projectModalShown = false;
        }

        $rootScope.$on('$stateChangeStart', (e, toState, toParams) => {
            console.log(toState.url, toParams.url, $state.is('studio-project') && $state.is('wave-project'), this.projectModalShown);
            if (($state.is('studio-project') || $state.is('wave-project')) && this.projectModalShown) {
                e.preventDefault();
                this.modalHide();
                if (_.isEqual(toParams, this.prevParams) && toState.name === this.prevState.name) { // in case we go to some url from modal
                    this.changeUrl(toState.name, toParams, true).then(() => {
                        SpinnerSvc.hide();
                    });
                } else {
                    $timeout(() => $state.transitionTo(toState.name, toParams));
                }
            }
        });
    }

    onModalClose() {
        window.history.back(); //It will call $stateChangeStart
    }

    modalHide() {
        this.projectModalShown = false;
    }

    modalShow(project: anm.Project) {
        SpinnerSvc.show();
        this.$ocLazyLoad.load(animatronProject).then(() => {
            const product = Utils.getProductByState(this.$state).toLowerCase();
            const params: anm.ProjectModalStateParams  = {projectId: project.id, project};

            if (product === 'wave') {
                params.stopPlay = true;
            }

            const state = [`${product}-project`, params];
            if (options.handHeld) {
                (<any>this.$state.go)(...state);
            } else {
                this.prevState = this.$state.current;
                this.prevParams = this.$state.params;
                delete this.prevParams['#'];
                this.projectModalShown = true;
                (<any>this.changeUrl)(...state);
            }
        });
    };

    toggleProjectModal(project: anm.Project, $event: MouseEvent) {
        if (!$event.metaKey && !$event.ctrlKey) {
            $event.preventDefault();
            if (this.projectModalShown) {
                this.modalHide();
            } else {
                this.modalShow(project);
            }
        }
    };

    private changeUrl(state: string, params: any, replace = false) {
        const opts = {
            notify: false,
            location: (replace ? 'replace' : true)
        };
        return this.$state.transitionTo(state, params, opts);
    }

}

services.service('ProjectModalSvc', ProjectModalSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/ProjectModalSvc.ts